import { Input, KeyCode } from "../../lib/Input";
import MonoBehavior from "../../lib/MonoBehavior";
import { Time } from "../../lib/Time";
import Vector2 from "../../math/Vector2";
import { clamp01 } from "../../util";
import Color from "../../util/Color";
import Explosion from "../Explosion";
import SPAbility from "../SPAbility";
import SPBogey from "../SPBogey";
import SPBullet from "../SPBullet";
import SPGameManager from "../SPGameManager";
import SPPlayer from "../SPPlayer";

export class PlasmaWaveBehavior extends MonoBehavior {
    width = 5;
    size = 0;
    lifetime = 3;
    color = new Color(128, 80, 255);
    hits: string[] = [];

    get alpha() {return clamp01(1 - this.timeAlive / this.lifetime);}

    Start(): void {
        this.engine.NewGameObjectWithScript(Explosion, {
            position: this.transform.position.clone(),
            initialValues: {
                size: 64,
                w: 128,
                color: this.color
            }
        });
    }

    Update(): void {
        if (!SPGameManager.Singleton.isInGame) return;
        if (this.alpha <= 0) {
            this.engine.RemoveGameObject(this.gameObject);
            return;
        }

        const validBogeys = this.engine.GetGameObjectsBehaviors<SPBogey>(SPBogey).filter(
            v => !this.hits.includes(v.id)
        );

        for (const bogey of validBogeys) {
            //if the distance from bogey to this is within a threshold (width) of the current size
            //then they are at the damage perimeter
            const dist = Vector2.distance(this.transform.position, bogey.transform.position);

            if (Math.abs(dist - this.size) <= this.width) {
                this.hits.push(bogey.id);
                bogey.Damage(5);
                this.engine.NewGameObjectWithScript<Explosion>(Explosion, {
                    position: bogey.transform.position,
                    initialValues: {
                        size: 2,
                        w: 4,
                        color: Color.fromHex("#ffffff")
                    }
                });
            }
        }

        this.size += 128 * Time.deltaTime;
    }

    Draw(): void {
        this.ctx.lineWidth = this.width;
        this.ctx.strokeStyle = this.color.toHexWithAlpha(this.alpha);
        this.engine.StrokeCircle(this.transform.position, this.size);
    }

}

export default class PlasmaWave extends SPAbility {

    constructor(player: SPPlayer) {
        super(player, {
            cooldown: 30,
            duration: 0,
            icon: 2,
            trigger: KeyCode.Digit1,
            triggerType: Input.GetKeyDown
        });
    }

    onUse(): void {
        this.player.engine.NewGameObjectWithScript(PlasmaWaveBehavior, {
            position: this.player.transform.position
        });
    }

}